import { format } from 'date-fns';

import { BffBrandType } from '@/gqlConstants';
import { getGraphHeaders } from '@/utils/getGraphHeaders';
import { logWarning } from '@/utils/miscUtils';
import { BffAvailabilityByLocationQuery } from '@/graphql/__generated/sdk';

export const getBffAvailabilityByLocation = async (
	brand: BffBrandType,
	facilityId: string,
	url: string,
	appName: string,
	appVersion: string,
	startDate?: Date,
	endDate?: Date
): Promise<BffAvailabilityByLocationQuery | null> => {
	const dateFrom = startDate ?? new Date();
	const dateTo = endDate ?? new Date(dateFrom).setDate(dateFrom.getDate() + 2); // format: 2025-06-24

	try {
		if (!brand) {
			return null;
		}
		const { getGraphQLClient } = await import(
			/* webpackChunkName:"getGraphQLClient" */ '../graphql/getGraphQLClient'
		);

		const variables = {
			brand,
			facilityId,
			appointmentTypes: ['ROUTINE_CHECKUP', 'SICK_URGENT'],
			dateFrom: format(dateFrom, 'yyyy-MM-dd'),
			dateTo: format(dateTo, 'yyyy-MM-dd'),
		};
		const headers = getGraphHeaders(appName, appVersion);
		return await getGraphQLClient(url).bffAvailabilityByLocation(variables, headers);
	} catch (err) {
		logWarning(
			`MISSING_AVAILABILITY_RESULTS: ${brand} for query. Error: ${
				err instanceof Error ? err.message : String(err)
			}`
		);
		return null;
	}
};
